import { createSelector } from 'reselect'

import { RootState } from 'redux/types'

import { FavouritesState, HiddenFavouritesData, NormalizedFavourites } from './types'

const getFavouritesState = (state: RootState): FavouritesState => state.favourites

// Loading
const getIsFavouritesLoading = createSelector<
  RootState,
  FavouritesState,
  FavouritesState['isFavouritesLoading']
>(getFavouritesState, (state: FavouritesState) => state.isFavouritesLoading)

const getIsFavouritesPopulated = createSelector<
  RootState,
  FavouritesState,
  FavouritesState['isFavouritesPopulated']
>(getFavouritesState, (state: FavouritesState) => state.isFavouritesPopulated)

const getIsFavouritesLoaded = createSelector<
  RootState,
  FavouritesState,
  FavouritesState['isFavouritesPopulated']
>(getFavouritesState, (state: FavouritesState) => state.isFavouritesLoaded)

// Items
const getFavouritesItems = createSelector<RootState, FavouritesState, NormalizedFavourites[] | []>(
  getFavouritesState,
  (state: FavouritesState) => state.items || [],
)

const getFavouritesHiddenItems = createSelector<
  RootState,
  FavouritesState,
  HiddenFavouritesData[] | []
>(getFavouritesState, (state: FavouritesState) => state.hiddenItems || [])

// Store - TODO: Update ResultOutputType when ANY is replaced in types.ts
const getStoreSearchResultsItems = createSelector<RootState, FavouritesState, any>(
  getFavouritesState,
  (state) => state.storeSearchResults || [],
)

// Size guide
const itemSizeGuideResult = createSelector<
  RootState,
  FavouritesState,
  FavouritesState['itemSizeGuideResult']
>(getFavouritesState, (state) => state.itemSizeGuideResult || '')

// Add to Bag
const getAddToBagVerificationItem = createSelector<
  RootState,
  FavouritesState,
  FavouritesState['addToBagVerificationItem']
>(getFavouritesState, (state) => state.addToBagVerificationItem || {})
const getShowAddToBagVerification = createSelector<
  RootState,
  FavouritesState,
  FavouritesState['showAddToBagVerification']
>(getFavouritesState, (state) => state.showAddToBagVerification)

const getAddToBagError = createSelector<
  RootState,
  FavouritesState,
  FavouritesState['addToBagVerificationError']
>(getFavouritesState, (state) => state.addToBagVerificationError || {})

// Error
const getFavouritesError = createSelector<
  RootState,
  FavouritesState,
  FavouritesState['favouritesError']
>(getFavouritesState, (state) => state.favouritesError || {})

const getFavouritesErrorMode = createSelector<
  RootState,
  FavouritesState['favouritesError'],
  FavouritesState['favouritesError']['displayMode']
>(getFavouritesError, (state) => state.displayMode)

export {
  getIsFavouritesLoading,
  getIsFavouritesPopulated,
  getIsFavouritesLoaded,
  getFavouritesItems,
  getFavouritesHiddenItems,
  getStoreSearchResultsItems,
  getAddToBagVerificationItem,
  getShowAddToBagVerification,
  getAddToBagError,
  getFavouritesError,
  getFavouritesErrorMode,
  itemSizeGuideResult,
}
